import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ClipboardList, BarChart3, History, Settings } from "lucide-react";

export const BottomNav = () => {
  const { pathname } = useLocation();
  const { isAdmin } = useAuth();

  const items = [
    { to: "/", label: "Order", icon: ClipboardList, testid: "nav-order" },
    { to: "/inventory", label: "Inventory", icon: BarChart3, testid: "nav-inventory" },
    { to: "/history", label: "History", icon: History, testid: "nav-history" },
  ];
  if (isAdmin) items.push({ to: "/admin", label: "Admin", icon: Settings, testid: "nav-admin" });

  const isActive = (to) =>
    to === "/" ? pathname === "/" : pathname.startsWith(to);

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-30 pointer-events-none" data-testid="bottom-nav">
      <div className="max-w-md mx-auto px-4 pb-4 pointer-events-none">
        <div className="pointer-events-auto bg-white/95 backdrop-blur-lg border border-brand-200 rounded-3xl shadow-[0_8px_32px_rgba(60,30,0,0.08)] flex justify-around items-center px-3 py-2">
          {items.map(({ to, label, icon: Icon, testid }) => {
            const active = isActive(to);
            return (
              <Link
                key={to}
                to={to}
                className={`flex flex-col items-center gap-1 px-3 py-2 rounded-2xl transition-colors ${
                  active ? "text-brand-700" : "text-stone-400 hover:text-brand-700"
                }`}
                data-testid={testid}
              >
                <Icon className="w-5 h-5" strokeWidth={active ? 2 : 1.6} />
                <span className="text-[11px] font-medium tracking-tight">{label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
};
